import type { CSSProperties, ReactNode } from 'react';

export type TagTone = 'neutral' | 'ice' | 'ok' | 'warn' | 'fail';

interface TagProps {
  children: ReactNode;
  tone?: TagTone;
  style?: CSSProperties;
}

const tones: Record<TagTone, { bg: string; fg: string; br: string }> = {
  neutral: { bg: 'var(--ink-100)', fg: 'var(--ink-600)', br: 'var(--ink-200)' },
  ice: { bg: 'var(--tint-ice-bg)', fg: 'var(--tint-ice-fg)', br: 'var(--tint-ice-br)' },
  ok: { bg: 'var(--tint-ok-bg)', fg: 'var(--tint-ok-fg)', br: 'var(--tint-ok-br)' },
  warn: { bg: 'var(--tint-warn-bg)', fg: 'var(--tint-warn-fg)', br: 'var(--tint-warn-br)' },
  fail: { bg: 'var(--tint-fail-bg)', fg: 'var(--tint-fail-fg)', br: 'var(--tint-fail-br)' },
};

export default function Tag({ children, tone = 'neutral', style }: TagProps) {
  const t = tones[tone];
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '2px 8px',
        borderRadius: 999,
        fontFamily: 'var(--font-mono)',
        fontSize: 11,
        letterSpacing: '0.02em',
        background: t.bg,
        color: t.fg,
        border: `1px solid ${t.br}`,
        ...style,
      }}
    >
      {children}
    </span>
  );
}
